import styled from 'styled-components'
import { rgba, colors } from 'styles'

const StyledSpinningCircle = styled.div`
  display: inline-block;
  width: 5rem;
  height: 5rem;

  border: 5px solid ${rgba(colors.textMain, 0.6)};
  border-top-color: ${colors.main};
  border-radius: 50%;

  animation: spin 1.5s ease-in-out infinite;

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
`

export default StyledSpinningCircle
